import { render, staticRenderFns } from "./ListSeguroicontratarPage.vue?vue&type=template&id=179047dc"
import script from "./ListSeguroicontratarPage.vue?vue&type=script&lang=js"
export * from "./ListSeguroicontratarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports